export function headerInit() {
	document.addEventListener( 'DOMContentLoaded', function() {
		if ( document.getElementById( 'masthead' ) ) {
			const submenuButton = document.querySelectorAll( '.open-submenu' );
			const menuItems = document.querySelectorAll( 'li.menu-item-has-children' );
			let timer;
			const mqLarge = window.matchMedia( '(min-width: 768px)' );
			const allMenuItems = document.querySelectorAll( '.menu-item' );

			//Toggle logic for button submenu buttons
			if ( submenuButton ) {
				submenuButton.forEach( ( el ) =>
					el.addEventListener( 'click', ( event ) => {
						const subMenu = event.target.closest( '.menu-item-has-children' );
						subMenu.classList.toggle( 'open' );

						const currentActiveMenuItemParent = event.target.closest( 'li' );
						allMenuItems.forEach( ( item ) => {
							// Close all other dropdown menus if menu is not active menu item.
							if ( item.classList.contains( 'menu-item-has-children' ) && ( item !== currentActiveMenuItemParent ) ) {
								item.classList.remove( 'open' );
								item.querySelector( '.open-submenu' ).setAttribute( 'aria-expanded', 'false' );
							}
						} );

						// Change aria-expanded based which dropdown menu is open.
						if ( subMenu.classList.contains( 'open' ) ) {
							subMenu.querySelector( '.open-submenu' ).setAttribute( 'aria-expanded', 'true' );
						} else {
							subMenu.querySelector( '.open-submenu' ).setAttribute( 'aria-expanded', 'false' );
						}
					} )
				);
			}

			// Header open logic
			const openMobileHeader = () => {
				setTimeout( () => {
					// Without timeout focus doesn't get focus to close button.
					document.getElementById( 'mobile-nav-close' ).focus();
				}, '10' );

				document.getElementById( 'site-navigation' ).classList.toggle( 'active' );
				document.getElementById( 'mobile-nav-open' ).classList.add( 'hidden' );
				document.getElementById( 'mobile-nav-close' ).classList.remove( 'hidden' );
				document.getElementById( 'masthead' ).classList.add( 'mobilemenu-open' );
				document.body.classList.add( 'prevent-scrolling' );

				// Handle resizing and based on the screen size,
				// and close menu overlay on desktop.
				addEventListener( 'resize', () => {
					if ( window.innerWidth > 768 ) {
						document.getElementById( 'site-navigation' ).classList.remove( 'active' );
						document.getElementById( 'mobile-nav-open' ).classList.remove( 'hidden' );
						document.getElementById( 'mobile-nav-close' ).classList.add( 'hidden' );
						document.getElementById( 'masthead' ).classList.remove( 'mobilemenu-open' );
						document.body.classList.remove( 'prevent-scrolling' );
					}
				} );
			};

			const closeMobileHeader = () => {
				setTimeout( () => {
					// Without timeout focus doesn't get focus to close button.
					document.getElementById( 'mobile-nav-open' ).focus();
				}, '10' );
				document.getElementById( 'site-navigation' ).classList.toggle( 'active' );
				document.getElementById( 'mobile-nav-open' ).classList.remove( 'hidden' );
				document.getElementById( 'mobile-nav-close' ).classList.add( 'hidden' );
				document.getElementById( 'masthead' ).classList.remove( 'mobilemenu-open' );
				document.body.classList.remove( 'prevent-scrolling' );
			};

			document.getElementById( 'mobile-nav-open' ).addEventListener( 'click', openMobileHeader );
			document.getElementById( 'mobile-nav-close' ).addEventListener( 'click', closeMobileHeader );

			//Functions for menu hover actions
			function openHoverMenu() {
				Array.prototype.forEach.call( menuItems, function( el ) {
					if ( el.classList.contains( 'open' ) ) {
						el.classList.remove( 'open' );
					}
				} );

				this.classList.add( 'open' );
				clearTimeout( timer );
			}

			function closeHoverMenu() {
				timer = setTimeout( function() {
					document.querySelector( '.menu-item-has-children.open' ).classList.remove( 'open' );
				}, 500 );
			}

			//Handle mouseover actions and listening in desktop
			function handleDesktopChange( e ) {
				//Run if breakpoint large or bigger
				if ( e.matches ) {
					Array.prototype.forEach.call( menuItems, function( el ) {
						el.addEventListener( 'mouseover', openHoverMenu );
						el.addEventListener( 'mouseout', closeHoverMenu );
					} );
				} else {
					//On tablet and mobile, remove event listeners from menu items that have children
					Array.prototype.forEach.call( menuItems, function( el ) {
						el.removeEventListener( 'mouseover', openHoverMenu );
						el.removeEventListener( 'mouseout', closeHoverMenu );
					} );
				}
			}

			// Register event listener to listen screen width changes
			mqLarge.addListener( handleDesktopChange );

			// Initial check
			handleDesktopChange( mqLarge );

			// Header scroll logic
			let prevScroll = window.scrollY;
			const header = document.querySelector( 'header' );
			const top = header.offsetTop + 130;

			window.onscroll = () => {
				const currentScroll = window.scrollY;

				if ( currentScroll >= top ) {
					header.classList.add( 'static' );
				} else {
					header.classList.remove( 'static' );
				}

				if ( prevScroll >= currentScroll ) {
					header.style.top = '0';
				}

				prevScroll = currentScroll;
			};

			// Focus trapping example taken from: https://medium.com/@im_rahul/focus-trapping-looping-b3ee658e5177
			function MobileMenuKeyboardHandler( e ) {
				/// Get all links from menu.
				const menuLinks = document.getElementById( 'site-navigation' ).getElementsByTagName( 'a' );

				if ( menuLinks ) {
					// Nav close button.
					const navCloseButton = document.getElementById( 'mobile-nav-close' );

					// Get last link from menu.
					const lastLinkInMenuIndex = menuLinks.length - 1;

					// Get last link from menu.
					const lastLinkInMenu = menuLinks[ lastLinkInMenuIndex ];

					if ( e.key === 'Tab' ) {
						// Rotate Focus
						// eslint-disable-next-line @wordpress/no-global-active-element
						if ( e.shiftKey && document.activeElement === navCloseButton ) {
							e.preventDefault();
							lastLinkInMenu.focus();
							// eslint-disable-next-line @wordpress/no-global-active-element
						} else if ( ! e.shiftKey && document.activeElement === lastLinkInMenu ) {
							e.preventDefault();
							navCloseButton.focus();
						}
					}
				}

				// Close mobile menu when pressing escape key.
				setTimeout( () => {
					if ( document.getElementById( 'masthead' ).classList.contains( 'mobilemenu-open' ) ) {
						if ( e.key === 'Escape' ) {
							setTimeout( () => {
								// Without timeout focus doesn't get focus to close button.
								document.getElementById( 'mobile-nav-open' ).focus();
							}, '10' );
							document.getElementById( 'site-navigation' ).classList.toggle( 'active' );
							document.getElementById( 'mobile-nav-open' ).classList.remove( 'hidden' );
							document.getElementById( 'mobile-nav-close' ).classList.add( 'hidden' );
							document.getElementById( 'masthead' ).classList.remove( 'mobilemenu-open' );
							document.body.classList.remove( 'prevent-scrolling' );
						}
					}
				}, '10' );

				// Close submenus when pessing escape key.
				if ( e.key === 'Escape' ) {
					allMenuItems.forEach( ( item ) => {
						if ( item.classList.contains( 'open' ) ) {
							item.classList.remove( 'open' );
							item.querySelector( '.open-submenu' ).setAttribute( 'aria-expanded', 'false' );
						}
					} );

					// Search is closed by pressing the esc button.
					closeSearch();
				}
			}
			document.addEventListener( 'keydown', MobileMenuKeyboardHandler );

			function handleAriaRole() {
				// When DOM is loaded role attribute will be added to navigation.
				if ( window.innerWidth < 768 ) {
					document.getElementById( 'site-header-top' ).setAttribute( 'role', 'dialog' );
					document.getElementById( 'site-header-top' ).setAttribute( 'aria-modal', 'true' );
				}

				// Handle resizing and based on the screen size,
				// role will be added or removed from navigation.
				addEventListener( 'resize', () => {
					if ( window.innerWidth < 768 ) {
						document.getElementById( 'site-header-top' ).setAttribute( 'role', 'dialog' );
						document.getElementById( 'site-header-top' ).setAttribute( 'aria-modal', 'true' );
					} else {
						document.getElementById( 'site-header-top' ).removeAttribute( 'role', 'dialog' );
						document.getElementById( 'site-header-top' ).removeAttribute( 'aria-modal', 'true' );
					}
				} );
			}

			handleAriaRole();

			// Language switcher.
			const langToggle = document.querySelector( '#site-header-menu-lang__toggle' );
			const toggleArrow = langToggle.lastElementChild;
			const langMenuPanel = document.querySelector( '#site-header-menu-lang__panel' );

			const toggleLanguageMenu = () => {
				if ( langToggle.hasAttribute( 'aria-controls' ) ) {
					langToggle.removeAttribute( 'aria-controls' );
				} else {
					langToggle.setAttribute( 'aria-controls', 'site-header-menu-lang__panel' );
				}

				toggleArrow.classList.toggle( 'reversed' );
				langMenuPanel.classList.toggle( 'visible' );

				if ( langMenuPanel.classList.contains( 'visible' ) ) {
					langToggle.setAttribute( 'aria-expanded', 'true' );
					langMenuPanel.querySelector( '.site-header-menu-lang__panel-list-item a' ).focus();
				} else {
					langToggle.setAttribute( 'aria-expanded', 'false' );
					langToggle.focus();
				}
			};

			// Event listener for click and keyboard.
			langToggle.addEventListener( 'click', toggleLanguageMenu );

			// Close the language menu with Escape key
			document.addEventListener( 'keydown', ( event ) => {
				if ( event.key === 'Escape' && langMenuPanel.classList.contains( 'visible' ) ) {
					toggleLanguageMenu();
					langToggle.focus();
				}
			} );

			// Notice that site has two different search forms one in mobilemenu and one in header.
			const search = document.getElementsByClassName( 'search-form' )[ 0 ];
			const searchLabel = search.getElementsByClassName( 'search-form--label' )[ 0 ];
			const searchInput = search.getElementsByClassName( 'search-form--input' )[ 0 ];
			const searchSubmit = search.getElementsByClassName( 'search-form--submit' )[ 0 ];
			const searchClose = search.getElementsByClassName( 'search-form--close' )[ 0 ];
			// Mobilemenu search
			const searchMobile = document.getElementsByClassName( 'search-form' )[ 1 ];
			const searchLabelMobile = searchMobile.getElementsByClassName( 'search-form--label' )[ 0 ];
			const searchInputMobile = searchMobile.getElementsByClassName( 'search-form--input' )[ 0 ];

			const openSearch = () => {
				search.classList.add( 'search__open' );
				searchInput.focus();
				if ( ! searchInput.value ) {
					searchLabel.style.display = 'none';
				} else {
					searchLabel.style.display = 'block';
				}
			};

			const closeSearch = () => {
				search.classList.remove( 'search__open' );
				searchLabel.style.display = 'flex';
			};

			searchLabel.onclick = function( e ) {
				e.preventDefault();
				if ( search.classList.contains( 'search__open' ) ) {
					searchSubmit.click();
				} else {
					openSearch();
				}

				e.stopPropagation();
			};
			searchInput.onclick = function( e ) {
				openSearch();
				e.stopPropagation();
			};
			searchInput.onkeydown = function( e ) {
				if ( ( e.key === 'Backspace' || e.key === 'Delete' ) && searchInput.value.length <= 1 ) {
					searchLabel.style.display = 'none';
				} else {
					searchLabel.style.display = 'block';
				}
			};

			// Displaying a mobile menu label above the search input.
			searchInputMobile.onkeydown = function( e ) {
				if ( ( e.key === 'Backspace' || e.key === 'Delete' ) && searchInputMobile.value.length <= 1 ) {
					searchLabelMobile.style.display = 'none';
				} else {
					searchLabelMobile.style.display = 'block';
					searchMobile.classList.add( 'search__open' );
				}
			};

			searchInput.onkeyup = function() {
				if ( searchInput.value.length === 0 ) {
					searchLabel.style.display = 'none';
				} else {
					searchLabel.style.display = 'block';
				}
			};
			searchSubmit.onclick = function( e ) {
				if ( ! search.classList.contains( 'search__open' ) ) {
					e.preventDefault();
					openSearch();
				}
				e.stopPropagation();
			};
			searchClose.onclick = function() {
				closeSearch();
			};

			// Hide label from search input if there is no value added.
			searchInput.addEventListener( 'focusout', () => {
				if ( searchInput.value.length === 0 ) {
					searchLabel.style.display = 'none';
				}
			} );
			searchInputMobile.addEventListener( 'focusout', () => {
				if ( searchInputMobile.value.length === 0 ) {
					searchLabelMobile.style.display = 'none';
				}
			} );
		}
	} );
}
